import { render, staticRenderFns } from "./RecreateOrder.vue?vue&type=template&id=5cefaec7&scoped=true&lang=pug&"
import script from "./RecreateOrder.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecreateOrder.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecreateOrder.vue?vue&type=style&index=0&id=5cefaec7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cefaec7",
  null
  
)

export default component.exports